import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, FormGroup, FormControl, ControlLabel, Alert, Modal, Button, Col, Row, Grid } from 'rsuite';
import loginService from '../../services/login';
import usersService from '../../services/users';
import statuses from '../../constants/users/statuses';
import allRoles from '../../constants/roles/roles';
import { cuotitasUrl } from '../../services/abstract';

//
// Style
//
const disableInput = {
    backgroundColor: '#f7f9fa',
    border: '2px #c6cfd7 solid'
};
const ID_CUOTITAS_PLATFORM = 5;
const ROLES_USED = [allRoles['admin.cuotitas'], allRoles.cuotitas];

class UserProfile extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            usuario: this.props.user,
            query: new URLSearchParams(window.location.search),
            token: window.location.pathname.slice(7),
            email: '',
            showPerfil: false,
            showNewEmail: false,
            showNewPassword: false,
            role: false,
        };
        this.close = this.close.bind(this);
    }

    componentDidMount () {
        const paths = window.location.pathname.split('/');
        if (paths[1] === 'users' && this.state.token) {
            this.props.history.push('/dashboard');
        }

        this.getRole();
    }

    getRole () {
        for (const role of this.props?.user?.roles) {
            if (ROLES_USED.includes(role?.role?.id)) {
                this.setState({ ...this.state, role: role.role });
                break;
            }
        }
    }

    changeEmail = () => {
        // POST / auth / verify
        // send an email with token and id
        const body = {
            idPlatform: ID_CUOTITAS_PLATFORM,
            email: this.state.email, // new email to change
            metadata: {
                user: {
                    id: this.state.usuario.id,
                    fullname: this.state.usuario.formattedName
                },
                subject: 'Verificación de nuevo email',
                url: 'http://localhost:3000/users' // TODO verify again
            }
        };

        loginService
            .changeEmail(body)
            .then(response => {
                localStorage.setItem('newEmail', this.state.email);
                this.openModalPerfil();
                Alert.success('¡Listo! Ya te enviamos un mensaje a tu casilla de email para validar el cambio.', 5000);
            })
            .catch(e => {
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
                console.error(e);
            });
    };

    changePassword = () => {
        const email = this.state.usuario.person.email.description;

        const body = {
            idPlatform: ID_CUOTITAS_PLATFORM,
            email,
            metadata: {
                url: `${cuotitasUrl}/users/recover`
            }
        };

        loginService
            .forgot(body)
            .then(response => {
                Alert.success('Por favor revisar la casilla de mail ingresada y seguir los pasos para recuperar la contraseña.', 6000);
                this.props.history.push('/logout');
            })
            .catch(error => {
                console.error(error);
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 7000);
            });
    };

    saveEmail () {
        // Build register data
        const data = {
            idPlatform: ID_CUOTITAS_PLATFORM,
            person: {
                emails: [
                    {
                        idType: 1,
                        email: localStorage.getItem('newEmail')
                    }
                ]
            }
        };
        usersService
            .editById(this.state.usuario.id, data)
            .then(client => {
                Alert.success('Los cambios fueron guardados correctamente.', 5000);
            })
            .catch(e => {
                Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
            });
    }

    openModalPerfil = () => {
        this.setState(() => ({ ...this.state, showPerfil: true, showNewEmail: false, showNewPassword: false }));
    }

    openModalValidarEmail = () => {
        this.setState(() => ({
            ...this.state, showPerfil: false, showNewEmail: !this.state.showNewEmail
        }));
    }

    openModalChangePassword = () => {
        this.setState(() => ({
            ...this.state, showPerfil: false, showNewPassword: true
        }));
    }

    close () {
        this.setState({ ...this.state, showPerfil: false, showNewEmail: false, showNewPassword: false });
    }

    setEmail = (email) => {
        this.setState({ ...this.state, email });
    }

    render () {
        const { user } = this.props;
        const userName = user.person.attributes?.first_name.value || '';

        // Estilos

        const body0 = {
            width: '560px',
            padding: '0 4px'
        };

        return (
            <div>
                <Button appearance='subtle' onClick={this.openModalPerfil} >Hola,<b>{` ${this.state.usuario.formattedName}`}</b></Button>
                <div className="modal-container" >
                    <Modal show={this.state.showPerfil} onHide={this.close}>
                        <Modal.Header>
                            <Modal.Title />
                        </Modal.Header>
                        <Modal.Body style={{ paddingBottom: '24px' }}>
                            <div className='row m-0' style={body0}>
                                <div className='col-6 p-0'>
                                    <div className='d-flex justify-content-center align-items-center border rounded-lg' style={{ height: '100px', width: '100px', backgroundColor: '#e0f5ff' }} >
                                        <img alt="Pic" className="kt-hidden" src={user.pic} />
                                        <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success" style={{ fontSize: '3rem' }}>{userName.substring(0, 1)}</span>
                                    </div>

                                    <h4 className='py-4 font-weight-bold m-0'>{this.state.usuario.formattedName}</h4>
                                    <span className="label label-light-success label-pill label-inline" style={{ fontSize: '1rem' }}>
                                        {/* {this.state.usuario.status?.description || ''} */}
                                        {statuses[this?.state?.usuario?.status?.description].text || ''}
                                    </span>
                                </div>
                                <div className='col-6 p-0 w-100' >
                                    <Form
                                        fluid
                                    // formValue={{ name, lastname, document, email, role }}
                                    // onChange={() => { }}
                                    >
                                        {/* si está validado por RENAPER es de solo lectura */}

                                        <FormGroup className='mb-3'>
                                            <ControlLabel className='font-weight-bold'>DNI</ControlLabel>
                                            <FormControl
                                                style={disableInput}
                                                readOnly
                                                value={user.person.document?.description || ''}
                                            // onChange={setDocument}
                                            />
                                        </FormGroup>
                                        <FormGroup className='mb-3'>
                                            <ControlLabel className='font-weight-bold'>Rol</ControlLabel>
                                            <FormControl
                                                // className='border-dark'
                                                style={disableInput}
                                                readOnly
                                                value={this.state.role?.description || ''}
                                                // value={user.roles[0].role?.description || ''}
                                            // onChange={setName}
                                            />
                                        </FormGroup>
                                        <FormGroup className='mb-3'>
                                            <ControlLabel className='font-weight-bold'>Email</ControlLabel>
                                            <FormControl
                                                style={disableInput}
                                                readOnly
                                                value={user.person.email?.description || ''}
                                            // onChange={setLastname}
                                            />
                                        </FormGroup>
                                    </Form>
                                </div>
                            </div>
                            <hr className='font-weight-bold' style={{ margin: '12px 4px' }} />
                            <Grid fluid >
                                {/* <Row className="show-grid text-primary mb-2" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <Col xs={1} >
                                        <i className="fas fa-envelope text-primary"/>
                                    </Col>
                                    <Col xs={8}>
                                        <span onClick={this.openModalValidarEmail} className='h6'>
                                            Cambiar email
                                        </span>
                                    </Col>
                                </Row> */}

                                <Row className="show-grid text-primary" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                    <Col xs={1}>
                                        <i className="fas fa-unlock-alt text-primary"/>
                                    </Col>
                                    <Col xs={8}>
                                        <span onClick={this.openModalChangePassword} className='h6'>
                                            Cambiar contraseña
                                        </span>
                                    </Col>
                                </Row>
                            </Grid>

                        </Modal.Body>
                        <Modal.Footer>
                            <div className=" d-flex justify-content-start" style={{ padding: '0 4px', marginBottom: '32px' }}>
                                <Link
                                    to="/logout"
                                    className="btn btn-label-brand btn-sm btn-primary"
                                    style={{ fontSize: '1.25rem', padding: '6px 32px' }}
                                >
                                    Cerrar sesión
                                </Link>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    {/*  Segundo modal de cambio de email */}
                    <Modal show={this.state.showNewEmail} onHide={this.close} >
                        <Modal.Header>
                            <Modal.Title>Cambio de email</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ paddingBottom: '280px' }}>
                            <Form fluid>
                                <FormGroup >
                                    <ControlLabel className='font-weight-bold'>Nuevo email</ControlLabel>
                                    <FormControl
                                        className='w-100'
                                        value={this.state.email}
                                        onChange={this.setEmail}
                                    />
                                </FormGroup>
                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.openModalPerfil} appearance="subtle">
                                Volver
                            </Button>
                            <Button onClick={this.changeEmail} appearance="primary">
                                Validar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    {/*  Tercer modal de cambio de contraseña */}
                    <Modal show={this.state.showNewPassword} onHide={this.close} >
                        <Modal.Header>
                            <Modal.Title>Cambio de contraseña</Modal.Title>
                        </Modal.Header>
                        <Modal.Body >
                            <ControlLabel className='font-weight-bold' style={{ fontSize: '14px' }}>Para cambiar la contraseña es necesario cerrar sesión</ControlLabel>
                            <ControlLabel className='font-weight-bold' style={{ fontSize: '14px' }}>¿Está seguro de que desea hacerlo?</ControlLabel>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.openModalPerfil} appearance="subtle">
                                Volver
                            </Button>
                            <Button onClick={this.changePassword} appearance="primary">
                                Aceptar
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth: { user } }) => ({
    user
});

export default connect(mapStateToProps)(withRouter(UserProfile));
